import React from 'react'
import './Settings.scss'
import { useAuth } from '../../services/authContext'
import PropTypes from "prop-types";
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import LogoutIcon from '@mui/icons-material/Logout'
import GavelIcon from '@mui/icons-material/Gavel'
import PolicyIcon from '@mui/icons-material/Policy'
import LockResetIcon from '@mui/icons-material/LockReset'
import CloseIcon from '@mui/icons-material/Close'
import Divider from '@mui/material/Divider'
import { useNavigate } from 'react-router-dom'
import { Box, Drawer, Modal, Alert, Container } from '@mui/material'
import SignupForm from '../SignupForm/SignupForm'
import FormikForm from "../Utility/FormikForm";
import * as Yup from "yup";
import {
  delete_account
} from "../../services/apis";
import SEO from '../SEO/SEO';
import { getSeoData } from '../../utils/seoConfig';



const ImgStyle = {
  position: 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "40%", // Default width
  bgcolor: '#ffffff',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  color: '#e4b648',
  overflow: 'scroll',
  marginTop: '190px',
  maxHeight: '80vH',
  '@media (max-width: 600px)': { // Adjust the breakpoint as needed
    width: '100%', // Width for mobile devices
  }
};

const Settings = (onSuccess) => {
  const navigate = useNavigate()
  const { loginStatus } = useAuth()
  const [open, setOpen] = React.useState(false)
  const [formSubmitting, setFormSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);
  const seoData = getSeoData("/settings");
  const [deleteProductOpen, setDeleteProductOpen] = React.useState(false);

  const logOut = () => {
    localStorage.removeItem('loginCred')
    navigate('/')
    window.location.reload()
  }


  const handleUpdateSuccess = () => {
    setOpen(false);
  };

  const tnc = () => {
    navigate('/terms')
  }

  const pp = () => {
    navigate('/privacy')
  }

  const getInitialValues = () => {
    return {
      passcode: "",
    };
  };

  const formFields = [
    {
      name: "passcode",
      label: "Passcode",
      type: "password",
    }
  ];

  // Form validation schema - simplified for client
  const validationSchema = Yup.object({
    passcode: Yup.string().required("Passcode is required")
  });

  // Form submission handler
  const handleSubmit = async (values) => {
    try {
      setFormSubmitting(true);
      setError(null);

      const formData = new window.FormData();
      console.log("loginstatus", loginStatus)
      // Common fields for both create and update
      formData.append("username", loginStatus.user.username);
      formData.append("passcode", values.passcode);

      await delete_account(formData);
      logOut();

    } catch (error) {
      console.error(error);

      const message =
        typeof error?.response?.data === "string"
          ? error.response.data
          : error?.message || "Something went wrong";

      setError(message);
    } finally {
      setFormSubmitting(false);
    }
  };

  const settingsOptions = [
    // {
    //   label: 'Delete Account Permanently',
    //   icon: <DeleteSweepIcon color='primary' />,
    //   onClick: () => setDeleteProductOpen(true)
    // },
    {
      label: 'Update Profile',
      icon: <LockResetIcon color='primary' />,
      onClick: () => setOpen(true)
    },
    {
      label: 'Log Out',
      icon: <LogoutIcon color='primary' />,
      onClick: logOut
    },
    {
      label: 'Terms',
      icon: <GavelIcon color='primary' />,
      onClick: tnc
    },
    {
      label: 'Privacy and Other Policies',
      icon: <PolicyIcon color='primary' />,
      onClick: pp
    },
    // {
    //   label: `Themes - ${state}`,
    //   icon: <PaletteIcon color='primary' />,
    //   onClick: modeToggler
    // }
  ];

  return (
    <>
      <SEO {...seoData} />
      {loginStatus.token ? (
        <Container maxWidth="lg" className='Settings perfect-center-left' data-testid='Settings'>
          <List>
            {settingsOptions.map((item, index) => (
              <React.Fragment key={index}>
                <Divider sx={{ marginLeft: '0px', width: '100%' }} />
                <ListItem onClick={item.onClick} sx={{ cursor: 'pointer' }}>
                  <ListItemIcon sx={{ minWidth: '30px' }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.label} sx={{ fontWeight: 700 }} />
                </ListItem>
              </React.Fragment>
            ))}
            <Divider sx={{ marginLeft: '0px', width: '100%' }} />
          </List>
          <Drawer anchor='right' open={open} onClose={() => setOpen(false)}>
            <Box
              sx={{
                width: '100vw',
                bgcolor: 'white',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Box
                sx={{
                  bgcolor: '#000000',
                  color: 'white',
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <h2 style={{ margin: 0 }}>Update Profile</h2>
                <CloseIcon
                  onClick={() => setOpen(false)}
                  style={{
                    cursor: 'pointer',
                    color: 'white'
                  }}
                />
              </Box>
              <Box
                sx={{
                  padding: '16px',
                  flex: 1,
                  overflowY: 'auto'
                }}
              >
                <SignupForm handleUpdateSuccess={handleUpdateSuccess} />
              </Box>
            </Box>
          </Drawer>
          <Modal
            fullscreen
            open={deleteProductOpen}
            onClose={() => setDeleteProductOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{ ...ImgStyle, position: 'relative' }}>
              <CloseIcon
                onClick={() => setDeleteProductOpen(false)}
                style={{ position: 'absolute', top: 16, right: 16, cursor: 'pointer' }}
              />
              <h3>Are you sure you want to delete? No data will remain post that.</h3>
              <p>Enter your Passcode to Confirm</p>
              <Box>
                {error && <Alert sx={{ mb: 1 }} severity="error">{String(error)}</Alert>}
              </Box>
              <FormikForm
                initialValues={getInitialValues()}
                validationSchema={validationSchema}
                fields={formFields}
                onSubmit={handleSubmit}
                submitButtonText={"Okay"}
                isSubmitting={formSubmitting}
              />
            </Box>
          </Modal>
        </Container>
      ) : (
        <></>
      )}
    </>
  )
}

Settings.propTypes = {
  onSuccess: PropTypes.func
};

export default Settings
